import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";

export const StyledComingSoonLabelWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    filter: drop-shadow(0px 3px 6px rgba(14, 30, 62, 0.08));
`;

export const StyledLabelText = styled.div`
    display: flex;
    position: absolute;
    ${setFontVariant("tab", colorsPalettes.carbon[0])};
    font-size: 10px;
    font-weight: 400;
`;

export const StyledLabelIcon = styled(SWReactIcons)`
    display: flex;
    svg {
        height: 24px;
    }
`;
